'use strict';

/**
 * Global project configuration
 **/
export const GlobalConfig = Object.freeze({
    // DebugMode project
    _debugMode: true,
    // If the project is oneClient or multiClient. Use [url_client. ej. rebus] o false
    _isOneClient: 'inter_cartagena',
    // Default Language
    _defaultLang: 'es',
    // Domain
    _domain: 'http://localhost:9422',
    // Time Zone
    _timezone: 'America/Bogota',
    _timezoneHour: '-05:00',
    // Delay time execution of connect data. Use [Integer]
    _timeoutConnect: 20000
});
// end file



// WEBPACK FOOTER //
// ./src/app/app.config.ts